import Button from "./Button";
import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";

export default function Footer() {
  return (
    <>
      <div className=" bg-[#EEEFFB] w-full">
        <div className="max-w-5xl mx-auto mt-24 text-sub_text_color flex items-start justify-between pt-20 pb-16">
          {/* column 1 */}
          <div>
            <h1 className="text-4xl font-fontOne text-black font-bold mb-8">
              Hekto
            </h1>
            <form className="bg-white bg-opacity-25 flex pl-3 rounded-sm mb-8">
              <input
                className=" flex-1 focus:outline-none bg-[rgba(0,0,0,0)] "
                type="text"
                placeholder="Enter Email Address"
              />
              <Button className="ml-2" color="pink">
                Sign Up
              </Button>
            </form>
            <div>
              <p className="mb-2">Contact Info</p>
              <p>17 Princess Road, London, Greater London NW1 8JR, UK</p>
            </div>
          </div>

          {/* column 2 */}
          <div className="ml-3">
            <h2 className="text-xl mb-7 text-black font-fontOne font-bold">
              Catagories
            </h2>
            <ul className="">
              <li className="mb-4">Laptops & Computers</li>
              <li className="mb-4">Cameras & Photography</li>
              <li className="mb-4">Smart Phones & Tablets</li>
              <li className="mb-4">Video Games & Consoles</li>
              <li className="mb-4">Waterproof Headphones</li>
            </ul>
          </div>

          {/* column 3 */}
          <div className="ml-3">
            <h2 className="text-xl mb-7 text-black font-fontOne font-bold">
              Customer Care
            </h2>
            <ul>
              <li className="mb-4">My Account</li>
              <li className="mb-4">Dscount</li>
              <li className="mb-4">Returns</li>
              <li className="mb-4">Orders History</li>
              <li className="mb-4">Order Tracking</li>
            </ul>
          </div>

          {/* column 4 */}
          <div className="ml-3">
            <h2 className="text-xl mb-7 text-black font-fontOne font-bold">
              Pages
            </h2>
            <ul>
              <li className="mb-4">Blog</li>
              <li className="mb-4">Browse the Shop</li>
              <li className="mb-4">Category</li>
              <li className="mb-4">Pre-Built Pages</li>
              <li className="mb-4">Visual Composer Elements</li>
              <li className="mb-4">WooCommerece Pages</li>
            </ul>
          </div>
        </div>
      </div>
      {/* bottom part */}
      <div className=" bg-[#E7E4F8]">
        <div className="max-w-5xl mx-auto text-sub_text_color py-2 flex justify-between">
          {/* left */}
          <div>&#169; Ahmed Azad - All Rights Reserved</div>
          {/* right */}
          <div>
            <a href="/">
              <FaFacebook className="inline-block ml-3 text-text" />
            </a>
            <a href="/">
              <FaTwitter className="inline-block ml-3 text-text" />
            </a>
            <a href="/">
              <FaInstagram className="inline-block ml-3 text-text" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
